export const storageAuthToken = "UserIdentityToken";
export const storageAuthRefreshToken = "UserIdentityRefreshToken";
export const storageAuthInformation = "UserInformation";
export const storageAuthTokenValidTo = "UserIdentityTokenValidTo";
export const storageRoles = "UserRoles";
export const XSRFToken = "XSRF-TOKEN";
export const GroupToken = "SLOAN_GROUP_TOKEN";
export const groupAuthInformation = "GroupInformation";

// Identity Role
export const iAdmin = "system admin";
export const iUser = "user";

// Allowed Images
export const AllowedImages = "image/png,image/jpg,image/jpeg";